module.exports = __webpack_public_path__ + "fonts/AvenirLTStd-Book.f91ebc70.ttf";